export default __webpack_public_path__ + "static/media/all-in-carpets.8ecd46f2.webp";